import type { IDataIndicator, IGetIndicatorListParams } from '../types/index';

export abstract class CoverageRepository {
    abstract getIndicatorList(params?: IGetIndicatorListParams): Promise<IDataIndicator[]>;
}
